const hero = document.querySelector('.hero-title-wrapper');

// Нічого не робимо, якщо елементу немає (на інших сторінках)
if (hero) {
  window.addEventListener('scroll', () => {
    let offset = window.scrollY * 0.2;
    if (offset > 150) offset = 150;

    hero.style.transform = `translateY(-${offset}px)`;
  });
}
